import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getWidgetFieldDatatypeOptions } from '../../../../expressions/datatype/getWidgetFieldDatatypeOptions';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import {
  IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath';
import { WidgetType } from '../../../Widget';
import { isWidgetOptionValue } from '../common/option-list/isWidgetOptionValue';
import { IMultiSelectWidget } from './IMultiSelectWidget';
import { multiSelectOptionsObjectName } from './getMultiSelectOptionsObjectName';

export function getMultiSelectWidgetReference(
  path: IReferencePath,
  widget: IMultiSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.String,
      options: getWidgetFieldDatatypeOptions(widget),
    },
  };
}

/**
 * Ritorna una lista di reference per ogni opzione del widget
 */
export function getMultiSelectWidgetOptionsReferences(
  path: IReferencePath,
  widget: IMultiSelectWidget,
): IReference[] {
  return widget.options.filter(isWidgetOptionValue).map(option => ({
    type: ReferenceType.Widget,
    widgetType: WidgetType.Boolean,
    path: [
      ...path,
      {
        direction: ReferencePathDirection.Child,
        code: multiSelectOptionsObjectName(widget.code),
      },
    ],
    id: `${widget.id}-${option.value as string}`,
    code: option.value,
    label: `${widget.code}: ${option.value as string}`,
    field: {
      type: Datatype.Boolean,
    },
  }));
}
